class SidePanelSkillsController {
  constructor(UserDataService) {
    // Dependencies
    this.UserDataService = UserDataService;

    // User Data to watch
    this.userSkill = this.getUserSkill();
  }
  getUserSkill() {
    return this.UserDataService.skills.find((skill) => {
      return skill.id === this.skillId;
    });
  }
}

SidePanelSkillsController.$inject = ['UserDataService'];

export default SidePanelSkillsController;



// WEBPACK FOOTER //
// ./src/components/sidePanelSkills/sidePanelSkills.controller.js